<template>
  <Form
    class="flex flex-col gap-6 w-full"
    :resolver="featuredCausesResolver"
    :initialValues="initialValues"
    ref="featuredCausesForm"
    v-slot="$form"
    v-focustrap
  >
    <LabeledField
      v-if="showOrganizationsDropdown"
      label="Organizations"
      :field="$form.featuredOrganizations"
    >
      <FormField
        v-slot="$field"
        name="featuredOrganizations"
      >
        <input
          type="hidden"
          v-bind="$field.props"
          data-test="featured-organizations"
        />
      </FormField>
      <FeaturedCausesDropdown
        :selected="$form.featuredOrganizations?.value"
        @change="(organizations) => ($form.featuredOrganizations.value = organizations)"
      />
    </LabeledField>
  </Form>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import FeaturedCausesDropdown from './FeaturedCausesDropdown.vue';
import LabeledField from '@/components/forms/LabeledField.vue';

const companyAdminStore = useCompanyAdminStore();

const featuredCausesForm = ref(null);
const featuredCausesResolver = zodResolver(
  z.object({
    featuredCausesText: z.string().max(560, 'Maximum 560 characters allowed'),
    featuredOrganizations: z.array(z.number()),
  }),
);

const initialValues = computed(() => ({
  featuredCausesText: companyAdminStore.company.featuredCausesText,
  featuredOrganizations: companyAdminStore.company.featuredOrganizations,
}));

onMounted(() => {
  companyAdminStore.featuredCausesForm = featuredCausesForm.value;
});

const props = defineProps({
  showOrganizationsDropdown: {
    type: Boolean,
    default: true,
  },
});
</script>
